export default __webpack_public_path__ + "static/media/sidebar-3.4a1d1eff.jpg";